import type { Routes, UrlMatchResult, UrlSegment } from '@angular/router';

import { urlMatcher } from '#shell/utils/url-matcher';

enum CampaignsRoute {
    UNSUBSCRIBE_CAMPAIGN = 'unsubscribe_campaign',
    CAMPAIGN_REVIEW = 'campaign_review',
    EMAIL_VERIFICATION_SUCCESS = 'email_verification_success',
    EMAIL_VERIFICATION_FAILURE = 'email_verification_failure',
}

export function campaignsMatcher(segments: UrlSegment[]): UrlMatchResult | null {
    return urlMatcher(segments, CampaignsRoute);
}

export const LOGGED_OUT_CAMPAIGNS_ROUTES: Routes = [
    {
        path: CampaignsRoute.UNSUBSCRIBE_CAMPAIGN,
        loadComponent: () =>
            import('#modules/campaigns/views/unsubscribe-to-campaigns/unsubscribe-to-campaigns.component').then(
                (m) => m.UnsubscribeToCampaignsComponent
            ),
    },
    {
        path: CampaignsRoute.CAMPAIGN_REVIEW,
        children: [
            {
                path: 'give_review',
                loadComponent: () =>
                    import('#modules/campaigns/views/campaign-negative-review/campaign-negative-review.component').then(
                        (m) => m.CampaignNegativeReviewComponent
                    ),
            },
        ],
    },
    {
        path: CampaignsRoute.EMAIL_VERIFICATION_SUCCESS,
        loadComponent: () =>
            import('#modules/campaigns/views/email-verification-success/email-verification-success.component').then(
                (m) => m.EmailVerificationSuccessComponent
            ),
    },
    {
        path: CampaignsRoute.EMAIL_VERIFICATION_FAILURE,
        loadComponent: () =>
            import('#modules/campaigns/views/email-verification-failure/email-verification-failure.component').then(
                (m) => m.EmailVerificationFailureComponent
            ),
    },
];
